const IconUrls = {
  1: "/icons/new_window.svg",
  2: "/icons/list_alt.svg",
  3: "icons/list_alt.svg",
  4: "/icons/list_alt_check.svg",
  5: "icons/list_alt_check.svg",
  6: "/icons/planner_review.svg",
  7: "/icons/user_management.svg",
  8: "/icons/user_management.svg",
  9: "/icons/user_management.svg",
  10: "/icons/list_alt.svg",
  11: "/icons/list_alt.svg",
  12: "/icons/list_alt.svg",
  13: "/icons/list_alt.svg",
};

module.exports = IconUrls;
